var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBandnadaLogoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 791.6 231.04"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bandnada-logo-white_svg__cls-2{letter-spacing:-.04em}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bandnada-logo-white_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 148.17)",
    fontSize: 172.31,
    fill: "#fff",
    fontFamily: "Helvetica-Bold,Helvetica",
    fontWeight: 700,
    letterSpacing: "-.02em",
    id: "bandnada-logo-white_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, "b", /*#__PURE__*/React.createElement("tspan", {
    className: "bandnada-logo-white_svg__cls-2",
    x: 101.81,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 190.75,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 292.56,
    y: 0,
    letterSpacing: "-.06em"
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    x: 387.47,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    className: "bandnada-logo-white_svg__cls-2",
    x: 508.47,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 597.4,
    y: 0
  }, "da")))));
}
export default __webpack_public_path__ + "829e14e43e131d3fc185821c9558c931.svg";
export { SvgBandnadaLogoWhite as ReactComponent };